<template>
  <div class="order-query-page">
    <van-nav-bar v-if="!$inApp" left-arrow @click-left="backLastPage" :border="false" class="query-nav">
      <template #title>
        <span class="nav-title">订单查询</span>
      </template>
      <template #left>
        <img src="@/assets/icons/nav-back.png" style="width: 12px; height: 18px;" />
        <span style="color:#333;margin-left:4px;font-size:16px;">返回</span>
      </template>
      <template #right>
        <div @click="goToHelpPage" class="nav-service">
          <img src="@/assets/icons/customer-service.png" style="width: 17.5px; height: 17.5px;" />
          <span style="font-size:14px;margin-left:4px;color:#465CFF">联系客服</span>
        </div>
      </template>
    </van-nav-bar>

    <div class="hero-section" :class="{ 'hero-section--no-nav': $inApp }">
      <div class="hero-bg-container">
        <div class="hero-content">
          <div class="hero-title">查询改战区订单</div>
          <div class="hero-subtitle">支持订单号、商户订单号</div>
        </div>
        <img src="@/assets/order-query/hero-order-search.png" class="hero-img" />
      </div>

      <div class="search-box">
        <input v-model.trim="queryOrderNo" placeholder="请输入订单号 / 商户订单号" class="search-input" @keyup.enter="queryOrder" />
        <van-button type="info" round class="search-btn" :loading="orderQueryLoading" @click="queryOrder">查询</van-button>
      </div>
      <div class="search-help" @click="toggleTutorial">
        <img src="@/assets/order-query/icon-help.png" class="help-icon" />
        不知道订单号在哪？<span class="help-link">查看图示教程 &gt;</span>
      </div>
    </div>

    <div class="recent-orders" v-if="queryResult || queryEmpty">
      <div class="section-title">
        <img src="@/assets/order-query/section-marker.png" class="section-marker" />
        查询结果
        <span class="section-clear" @click="clearQueryResult">清除</span>
      </div>
      <div class="order-list" v-if="queryResult">
        <div class="order-card" @click="viewOrder(queryResult.orderNo)">
          <img :src="queryResult.gameIcon" class="order-game-icon" @error="hideIcon" />
          <div class="order-info">
            <div class="order-info-top">
              <div class="order-name">{{ queryResult.gameName }} · {{ queryResult.modifyTypeName }}</div>
              <div class="order-status" :class="statusClass(queryResult)">{{ statusText(queryResult) }}</div>
            </div>
            <div class="order-info-bottom">
              <div class="order-date">{{ queryResult.createTime }}</div>
              <div class="order-price" v-if="queryResult.price">¥{{ queryResult.price }}</div>
            </div>
            <div class="order-no-row">
              <div class="order-no">单号: {{ formatOrderNo(queryResult.orderNo) }}</div>
              <van-icon name="arrow" color="#ccc" />
            </div>
          </div>
        </div>
      </div>
      <van-empty v-else image="search" description="未查询到相关订单，请核对订单号" class="query-empty" />
    </div>

    <div class="recent-orders" v-if="!queryResult && !queryEmpty && cachedOrders.length > 0">
      <div class="section-title">
        <img src="@/assets/order-query/section-marker.png" class="section-marker" />
        最近订单 <span class="section-subtitle">来自本机缓存</span>
      </div>
      <div class="order-list">
        <div class="order-card" v-for="(order, index) in displayOrders" :key="index" @click="viewOrder(order.orderNo)">
          <img :src="order.gameIcon" class="order-game-icon" @error="hideIcon" />
          <div class="order-info">
            <div class="order-info-top">
              <div class="order-name">{{ order.gameName }} · {{ order.modifyTypeName }}</div>
              <div class="order-status" :class="statusClass(order)">{{ statusText(order) }}</div>
            </div>
            <div class="order-info-bottom">
              <div class="order-date">{{ order.createTime }}</div>
              <div class="order-price" v-if="order.price">¥{{ order.price }}</div>
            </div>
            <div class="order-no-row">
              <div class="order-no">单号: {{ formatOrderNo(order.orderNo) }}</div>
              <van-icon name="arrow" color="#ccc" />
            </div>
          </div>
        </div>
      </div>
      <div class="view-all-orders" v-if="cachedOrders.length > 3 && !showAllOrders" @click="showAllOrders = true">
        查看全部缓存订单 &gt;
      </div>
      <div class="cache-notice">
        <img src="@/assets/order-query/info.png" class="notice-icon" />
        订单记录保存在当前设备，清理缓存后将无法显示
      </div>
    </div>

    <!-- Tutorial Section -->
    <van-popup v-model="showTutorial" round closeable class="tutorial-popup">
      <div class="tutorial-section">
        <div class="tutorial-header">
          <div class="tutorial-title">
            <div class="help-circle">?</div>
            如何查询订单号？
          </div>
        </div>

      <div class="tutorial-tabs">
        <div class="tutorial-tab" :class="{active: activeTab === 'wechat'}" @click="activeTab = 'wechat'">
          <img src="@/assets/order-query/icon-wechat.png" class="tab-icon" />
          微信支付
        </div>
        <div class="tutorial-tab" :class="{active: activeTab === 'alipay'}" @click="activeTab = 'alipay'">
          <img src="@/assets/order-query/icon-alipay.png" class="tab-icon" />
          支付宝
        </div>
        <div class="tab-indicator" :class="activeTab"></div>
      </div>
      <div class="tutorial-steps-wrapper">
        <template v-if="activeTab === 'wechat'">
          <div class="tutorial-step">
            <div class="step-header">
              <span class="step-num wechat-num">1</span><span class="step-text">找到微信支付记录</span>
            </div>
            <img src="@/assets/order-query/wechat-step-1-service-notification.png" class="step-img" @click="previewImage(require('@/assets/order-query/wechat-step-1-service-notification.png'))" />
          </div>
          <img src="@/assets/order-query/icon-step-arrow.png" class="step-arrow" />
          <div class="tutorial-step">
            <div class="step-header">
              <span class="step-num wechat-num">2</span><span class="step-text">进入账单详情</span>
            </div>
            <img src="@/assets/order-query/wechat-step-2-bill-detail.png" class="step-img" @click="previewImage(require('@/assets/order-query/wechat-step-2-bill-detail.png'))" />
          </div>
          <img src="@/assets/order-query/icon-step-arrow.png" class="step-arrow" />
          <div class="tutorial-step">
            <div class="step-header">
              <span class="step-num wechat-num">3</span><span class="step-text">复制商户单号</span>
            </div>
            <img src="@/assets/order-query/wechat-step-3-copy-merchant-order.png" class="step-img" @click="previewImage(require('@/assets/order-query/wechat-step-3-copy-merchant-order.png'))" />
          </div>
        </template>
        <template v-else>
          <div class="tutorial-step">
            <div class="step-header">
              <span class="step-num alipay-num">1</span><span class="step-text">打开支付宝账单</span>
            </div>
            <img src="@/assets/order-query/alipay-step-1-open-bills.png" class="step-img" @click="previewImage(require('@/assets/order-query/alipay-step-1-open-bills.png'))" />
          </div>
          <img src="@/assets/order-query/icon-step-arrow.png" class="step-arrow" />
          <div class="tutorial-step">
            <div class="step-header">
              <span class="step-num alipay-num">2</span><span class="step-text">选择支付记录</span>
            </div>
            <img src="@/assets/order-query/alipay-step-2-select-payment.png" class="step-img" @click="previewImage(require('@/assets/order-query/alipay-step-2-select-payment.png'))" />
          </div>
          <img src="@/assets/order-query/icon-step-arrow.png" class="step-arrow" />
          <div class="tutorial-step">
            <div class="step-header">
              <span class="step-num alipay-num">3</span><span class="step-text">复制订单号</span>
            </div>
            <img src="@/assets/order-query/alipay-step-3-copy-order-number.png" class="step-img" @click="previewImage(require('@/assets/order-query/alipay-step-3-copy-order-number.png'))" />
          </div>
        </template>
      </div>

      <div class="tutorial-footer">
        <van-button type="info" round color="#165DFF" @click="showTutorial = false" class="got-it-btn">我知道了</van-button>
      </div>
    </div>
    </van-popup>
  </div>
</template>

<script>
import { NavBar, Icon, Button, Toast, Popup, ImagePreview, Empty } from "vant";
import { loadGames, gameIcon } from "@/utils/games";
import { addOrder, listOrders, removeOrder } from "@/utils/orderCache";

export default {
  components: {
    VanNavBar: NavBar,
    VanIcon: Icon,
    VanButton: Button,
    VanPopup: Popup,
    VanEmpty: Empty
  },
  data() {
    return {
      queryOrderNo: '',
      orderQueryLoading: false,
      games: [],
      cachedOrders: [],
      queryResult: null,
      queryEmpty: false,
      showAllOrders: false,
      showTutorial: false,
      activeTab: 'wechat'
    };
  },
  computed: {
    displayOrders() {
      return this.showAllOrders ? this.cachedOrders : this.cachedOrders.slice(0, 3);
    }
  },
  watch: {
    //清空输入框即退出查询结果态,回到本机缓存的最近订单列表
    queryOrderNo(val) {
      if (!val) {
        this.queryResult = null;
        this.queryEmpty = false;
      }
    }
  },
  methods: {
    backLastPage() {
      window.history.back();
    },
    goToHelpPage() {
      window.location.href = 'https://yxsaoma.com/help?type=war';
    },
    hideIcon(e) {
      e.target.style.display = 'none';
    },
    toggleTutorial() {
      this.showTutorial = true;
    },
    formatOrderNo(no) {
      if (!no) return '';
      if (no.length > 15) {
        return no.substring(0, 15) + '...';
      }
      return no;
    },
    previewImage(url) {
      ImagePreview([url]);
    },
    /**
     * 状态文案优先用后端下发的 orderStatusDesc(远端实时状态,最准确)。
     * 注意 bindStatus 是 -1~5 的进度状态机(-1未绑定/0待扫码/1等待处理/2正在修改/3完成/4失败/5黑名单),
     * 不是布尔值,不能用它判断"是否完成"。
     */
    statusText(order) {
      if (order.status === 2) return '已退款';
      if (order.status !== 1) return '未支付';
      if (order.bindStatus === -1) return '待填写战区';
      return order.orderStatusDesc || '处理中';
    },
    statusClass(order) {
      if (order.status === 2) return 'status-closed';
      if (order.status !== 1) return 'status-closed';
      //3=处理完成 绿色; 4=失败/5=黑名单 红色; 其余进行中 蓝色
      if (order.bindStatus === 3) return 'status-success';
      if (order.bindStatus === 4 || order.bindStatus === 5) return 'status-failed';
      return 'status-processing';
    },
    formatAmount(amount) {
      if (amount === null || amount === undefined || amount === '') return '';
      const n = Number(amount);
      return isNaN(n) ? '' : n.toFixed(2);
    },
    async fetchOrderDetails(orderNo) {
      try {
        const response = await this.$axios.get('/api/game/war/order/' + encodeURIComponent(orderNo));
        if (response.data && response.data.code === '0000') {
          return response.data.data;
        }
      } catch (e) {
        // ignore
      }
      return null;
    },
    async loadCachedOrders() {
      const history = listOrders();
      if (history.length === 0) {
        this.cachedOrders = [];
        return;
      }
      //并发拉取,避免 N 个订单串行 N 次往返
      const results = await Promise.all(history.map(no => this.fetchOrderDetails(no)));
      const validOrders = [];
      results.forEach((orderData, i) => {
        const orderNo = history[i];
        if (orderData) {
          validOrders.push(this.buildOrderCard(orderData, orderNo));
        } else {
          //后端查不到,说明订单已失效,顺手清出缓存,避免每次进页面都白请求一次
          removeOrder(orderNo);
        }
      });
      this.cachedOrders = validOrders;
    },
    /**
     * 把接口返回的订单详情组装成列表卡片所需结构,查询结果与本机缓存列表共用
     */
    buildOrderCard(orderData, fallbackOrderNo) {
      let gameName = '游戏';
      let modifyTypeName = '战区修改';
      let gIcon = '';
      const g = this.games.find(x => x.gameId === orderData.gameId);
      if (g) {
        gameName = g.name;
        gIcon = gameIcon(g);
        if (g.modifyTypes) {
          const mt = g.modifyTypes.find(x => x.value === orderData.modifyType);
          if (mt) modifyTypeName = mt.label;
        }
      }
      return {
        orderNo: orderData.orderNo || fallbackOrderNo,
        gameId: orderData.gameId,
        status: orderData.status,
        bindStatus: orderData.bindStatus,
        orderStatusDesc: orderData.orderStatusDesc,
        gameName: gameName,
        modifyTypeName: modifyTypeName,
        gameIcon: gIcon,
        price: this.formatAmount(orderData.amount),
        createTime: orderData.createTime || ''
      };
    },
    clearQueryResult() {
      this.queryResult = null;
      this.queryEmpty = false;
      this.queryOrderNo = '';
    },
    viewOrder(orderNo) {
      window.location.href = '/warzone/' + encodeURIComponent(orderNo) + '?from=history';
    },
    queryOrder() {
      const orderNo = this.queryOrderNo;
      if (!orderNo) {
        Toast('请输入订单号');
        return;
      }
      this.orderQueryLoading = true;
      this.queryResult = null;
      this.queryEmpty = false;
      this.$axios.get('/api/game/war/order/' + encodeURIComponent(orderNo)).then((response) => {
        this.orderQueryLoading = false;
        if (response.data && response.data.code === '0000') {
          const order = response.data.data || {};
          //查询结果就地展示,由用户确认后再点击进入详情
          this.queryResult = this.buildOrderCard(order, orderNo);
          if (order.status === 1) {
            addOrder(this.queryResult.orderNo);
          }
        } else {
          //订单不存在:展示空态,不再Toast、也不回落到最近订单列表
          this.queryEmpty = true;
        }
      }).catch(() => {
        this.orderQueryLoading = false;
        Toast('查询失败，请稍后重试');
      });
    }
  },
  async created() {
    try {
      this.games = await loadGames();
    } catch (e) {
      this.games = [];
    }
    this.loadCachedOrders();
  }
};
</script>

<style scoped>
.order-query-page {
  min-height: 100vh;
  background-color: #f7f8fa;
  padding-bottom: 30px;
  box-sizing: border-box;
}
.query-empty {
  padding: 24px 0;
  background: transparent;
}
.query-nav {
  background: transparent;
}
.nav-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
}
.nav-service {
  display: flex;
  align-items: center;
}

.hero-section {
  position: relative;
  margin-top: -46px; /* overlap navbar */
  padding-top: 66px;
  background: linear-gradient(180deg, #e6eeff 0%, #f7f8fa 100%);
}
.hero-section--no-nav {
  margin-top: 0;
  padding-top: 20px;
}
.hero-bg-container {
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  margin-bottom: 20px;
}
.hero-content {
  padding-top: 10px;
}
.hero-title {
  font-size: 24px;
  font-weight: bold;
  color: #1a1a1a;
  margin-bottom: 8px;
}
.hero-subtitle {
  font-size: 13px;
  color: #666;
}
.hero-img {
  width: 120px;
  height: auto;
  object-fit: contain;
}

.search-box {
  margin: 0 20px;
  background: #fff;
  border-radius: 12px;
  display: flex;
  align-items: center;
  padding: 6px 6px 6px 16px;
  box-shadow: 0 4px 16px rgba(70, 92, 255, 0.08);
}
.search-input {
  flex: 1;
  border: none;
  font-size: 14px;
  outline: none;
}
.search-input::placeholder {
  color: #999;
}
.search-btn {
  width: 80px;
  height: 40px;
  background-color: #165DFF;
  border: none;
  font-size: 15px;
}

.search-help {
  display: flex;
  align-items: center;
  margin: 16px 20px;
  font-size: 13px;
  color: #666;
}
.help-icon {
  width: 14px;
  height: 14px;
  margin-right: 6px;
}
.help-link {
  color: #165DFF;
}

.recent-orders {
  padding: 0 20px;
  margin-top: 20px;
}
.section-title {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 16px;
}
.section-marker {
  width: 4px;
  height: 14px;
  margin-right: 8px;
}
.section-subtitle {
  font-size: 12px;
  color: #999;
  font-weight: normal;
  margin-left: 8px;
}
.section-clear {
  margin-left: auto;
  font-size: 13px;
  color: #165DFF;
  font-weight: normal;
}

.order-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.order-card {
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  align-items: center;
}
.order-game-icon {
  width: 48px;
  height: 48px;
  border-radius: 10px;
  margin-right: 12px;
}
.order-info {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.order-info-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}
.order-name {
  font-size: 15px;
  font-weight: bold;
  color: #333;
}
.order-status {
  font-size: 13px;
  font-weight: 500;
}
.status-processing {
  color: #165DFF;
}
.status-success {
  color: #00B42A;
}
.status-closed {
  color: #86909C;
}
.status-failed {
  color: #F53F3F;
}
.order-info-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}
.order-date {
  font-size: 12px;
  color: #999;
}
.order-price {
  font-size: 15px;
  font-weight: bold;
  color: #333;
}
.order-no-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.order-no {
  font-size: 12px;
  color: #999;
}

.view-all-orders {
  text-align: center;
  font-size: 14px;
  color: #165DFF;
  margin-top: 16px;
}
.cache-notice {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #999;
  margin-top: 16px;
}
.notice-icon {
  width: 12px;
  height: 12px;
  margin-right: 4px;
}

.tutorial-popup {
  width: 94%;
  max-width: 375px;
  padding: 24px 0 20px;
  border-radius: 16px;
}
.tutorial-section {
  padding: 0 16px;
}
.tutorial-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.tutorial-title {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
  color: #333;
}
.help-circle {
  width: 18px;
  height: 18px;
  background: #165DFF;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  margin-right: 6px;
}
.tutorial-toggle {
  font-size: 13px;
  color: #165DFF;
  display: flex;
  align-items: center;
}

.tutorial-tabs {
  display: flex;
  margin-bottom: 24px;
  border-bottom: 1px solid #f0f0f0;
  position: relative;
}
.tutorial-tab {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 44px;
  font-size: 15px;
  color: #666;
  position: relative;
  cursor: pointer;
}
.tutorial-tab.active {
  color: #165DFF;
  font-weight: 600;
}
.tab-indicator {
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 50%;
  height: 3px;
  background-color: #165DFF;
  border-radius: 2px;
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.tab-indicator.wechat {
  transform: translateX(0);
}
.tab-indicator.alipay {
  transform: translateX(100%);
}
.tab-icon {
  width: 18px;
  height: 18px;
  margin-right: 6px;
}

.tutorial-steps-wrapper {
  display: flex;
  align-items: flex-start;
  min-height: 220px;
  justify-content: space-between;
  margin-bottom: 16px;
  overflow-x: auto;
}
.tutorial-steps-wrapper::-webkit-scrollbar {
  display: none;
}
.tutorial-step {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.step-header {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  height: 24px;
  white-space: nowrap;
}
.step-num {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  color: #fff;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 4px;
}
.wechat-num { background: #00B42A; }
.alipay-num { background: #165DFF; }
.step-text {
  font-size: 12px;
  color: #333;
  transform: scale(0.85);
  transform-origin: center;
  white-space: nowrap;
}
.step-img {
  width: 100%;
  max-width: 90px;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
}
.step-arrow {
  width: 12px;
  height: 12px;
  margin: 0 4px;
  margin-top: 80px;
  flex-shrink: 0;
}

.tutorial-footer {
  margin-top: 10px;
  text-align: center;
}
.got-it-btn {
  width: 160px;
  height: 40px;
  font-size: 15px;
  font-weight: 500;
}
</style>
